module.exports = __webpack_public_path__ + "assets/img/LTC029.92c83367.png";